import { ValidateErrorEntity } from 'rc-field-form/lib/interface';

export const isValidateFormErrorEntity = (error: unknown): error is ValidateErrorEntity => {
  return (
    typeof error === 'object' && error !== null && 'errorFields' in error && Array.isArray((error as any).errorFields)
  );
};
